
/* eslint-disable */
// const base_endpoint = "http://127.0.0.1:8000/api";  // Local Serve
// const base_endpoint = window.location.hostname == 'localhost' ? "http://127.0.0.1:8000/api" : "https://admin.centrosdeexperiencia.com/api"; // Producción
const base_endpoint = "https://admin.centrosdeexperiencia.com/api"; // Producción
// const base_endpoint = "https://stagingadmin.centrosdeexperiencia.com/api"; // Producción-test
// const base_endpoint = "http://sistema_reservas_admin.dv/api"; // DS
export default base_endpoint;